import React, { useState, useEffect } from 'react';
import { Box } from '@primer/react';
import LTText from '../LTText/index.js';
import { convertMsToMinutesAndSeconds } from '../../utils/functions.js';

var _excluded = ["timeInMs", "style"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var LTTimer = function LTTimer(_ref) {
  var _ref$timeInMs = _ref.timeInMs,
    timeInMs = _ref$timeInMs === void 0 ? "" : _ref$timeInMs,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(timeInMs),
    _useState2 = _slicedToArray(_useState, 2),
    currentTime = _useState2[0],
    setCurrentTime = _useState2[1];
  useEffect(function () {
    if (!timeInMs) {
      return;
    }
    var timer = setInterval(function () {
      setCurrentTime(function (prevTime) {
        if (prevTime <= 0) {
          clearInterval(timer);
          return 0;
        }
        return prevTime - 1000;
      });
    }, 1000);
    return function () {
      return clearInterval(timer);
    };
  }, [timeInMs]);
  var _ref2 = convertMsToMinutesAndSeconds(Number(currentTime)) || {},
    _ref2$initMinute = _ref2.initMinute,
    minutes = _ref2$initMinute === void 0 ? 0 : _ref2$initMinute,
    _ref2$initSeconds = _ref2.initSeconds,
    seconds = _ref2$initSeconds === void 0 ? 0 : _ref2$initSeconds;
  return /*#__PURE__*/React.createElement(Box, _extends({
    role: "timer",
    sx: {
      minWidth: "42px"
    }
  }, rest), /*#__PURE__*/React.createElement(LTText, {
    style: style,
    variant: LTText.TextVariant.SUBHEADER_BOLD
  }, minutes < 10 ? "0".concat(minutes) : minutes, ":", seconds < 10 ? "0".concat(seconds) : seconds));
};
LTTimer.displayName = "LTTimer";

export { LTTimer as default };
